<script lang="ts" setup>
defineProps({
  color: {
    default: 'gray',
    type: String as PropType<UButtonColor>,
  },
  icon: {
    default: '',
    type: String,
  },
  iconColor: {
    default: '',
    type: String,
  },
  label: {
    default: '',
    type: String,
  },
  minimizeOnMobile: {
    default: false,
    type: Boolean,
  },
  minimizeOnTablet: {
    default: false,
    type: Boolean,
  },
  prevent: {
    default: false,
    type: Boolean,
  },
  tooltip: {
    default: '',
    type: String,
  },
  variant: {
    default: undefined,
    type: String as PropType<UButtonVariant>,
  },
})

const emit = defineEmits<{
  click: []
}>()

function onClick() {
  emit('click')
}
</script>

<template>
  <UTooltip
    :popper="{ placement: 'bottom' }"
    :prevent="prevent"
    :text="tooltip"
  >
    <UButton
      class="w-fit text-xs uppercase"
      :color="color"
      :icon="icon"
      :label="label"
      size="md"
      :ui="{ icon: { base: iconColor } }"
      :variant="variant"
      @click="onClick"
    >
      <span
        v-if="label"
        :class="{
          'hidden md:inline': minimizeOnMobile,
          'hidden lg:inline': minimizeOnTablet,
        }"
      >
        {{ label }}
      </span>
    </UButton>
  </UTooltip>
</template>
